import { LitElement, html, css } from "lit";
import { customElement, state } from "lit/decorators.js";
import { consume } from "@lit/context";

import { recordsContext } from "../contexts/records-context";

@customElement("auto-form")
export class AutoForm extends LitElement {
  @consume({ context: recordsContext, subscribe: true })
  private _recordsData: Object;
  @state()
  private _makes: Array<string>;
  @state()
  private _make: string;
  @state()
  private _models: Array<string>;
  @state()
  private _model: string;
  @state()
  private _results: Array<string>;

  static styles = css`
    h2 {
      margin: 0;
      padding: 16px 0;
    }

    label {
      display: block;
      padding: 8px;
    }

    select {
      width: 100%;
      margin: 0;
      padding: 8px;
    }

    table {
      width: 100%;
      font-size: 10px;
      border-collapse: collapse;
    }

    td,
    th {
      border: 1px solid #999;
      padding: 2px;
    }
  `;

  connectedCallback() {
    super.connectedCallback();
    this._models = [];
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  _handleMakeClick(e) {
    this._results = [];
    this._make = e.target.value;
    this._models = [
      ...new Set(
        this._recordsData?.data?.records
          .filter((item: string) => item[1] === e.target.value)
          .map((item: string) => item[2]),
      ),
    ];
  }

  _handleModelClick(e) {
    this._model = e.target.value;
    this._results = this._recordsData?.data?.records.filter(
      (item: string) => item[1] === this._make && item[2] === this._model,
    );
  }

  _renderDataForm() {
    if (!this._recordsData?.success) {
      return html`Iegūstam datus...`;
    } else {
      this._makes = [
        ...new Set(
          this._recordsData?.data?.records
            .map((item: string) => item[1])
            .sort(),
        ),
      ];
      return html`
        <h2>Izvēlies auto ražotāju un modeli</h2>
        <form>
          <label for="mark">Auto ražotājs</label>
          <select id="mark" @change="${this._handleMakeClick}">
            <option>Izvēlies auto ražotāju</option>
            ${this._makes.map(
              (item) => html`<option value="${item}">${item}</option>`,
            )}
          </select>
          <label for="model">Auto modelis</label>
          <select id="model" @change="${this._handleModelClick}">
            <option>Izvēlies auto modeli</option>
            ${this._models.map(
              (item) => html`<option value="${item}">${item}</option>`,
            )}
          </select>
        </form>
        <p>Atrasta ${this._results?.length} automašīna</p>
        <table>
          <tr>
            <th>Ražotājs</th>
            <th>Modelis</th>
            <th>Tips</th>
            <th>Degviela</th>
            <th>Krāsa</th>
            <th>Reg. gads</th>
          </tr>
          ${this._results?.map(
            (item) =>
              html`<tr>
                <td>${item[1]}</td>
                <td>${item[2]}</td>
                <td>${item[3]}</td>
                <td>${item[4]}</td>
                <td>${item[5]}</td>
                <td>${item[6]}</td>
              </tr>`,
          )}
        </table>
      `;
    }
  }

  render() {
    return html` ${this._renderDataForm()} `;
  }
}
